import axios from "axios";
import { getBackendUrl } from "@/general";


const BASE_URL = "/movimientos/api/";


export const crudMovimientosSerialesProductos = async (context, typeAction, id, requestData) => {
  const ENDPOINT = "movimientoSerialProducto";

  let response;

  try {
    await context.$store.dispatch("statusLogin", context.$router);
    const { source } = await getBackendUrl();
    const paramsHeader = {
      "Authorization": `Bearer ${context.$store.state.user.token}`
    };

    switch (typeAction) {
      case "create":
        response = await axios.post(
          `${source}${BASE_URL}${ENDPOINT}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "read":
        response = await axios.get(
          `${source}${BASE_URL}${ENDPOINT}/${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
      case "update":
        response = await axios.put(
          `${source}${BASE_URL}${ENDPOINT}/${id}/`,
          requestData,
          {
            headers: paramsHeader
          }
        );
        break;
      case "delete":
        response = await axios.delete(
          `${source}${BASE_URL}${ENDPOINT}/${id}/`,
          {
            headers: paramsHeader
          }
        );
        break;
    }

    return response.data;
  } catch (err) {
    console.log(err.response);
    throw err;
  }
}
